// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.approve-options-dialog {
  width: 100%;
  max-height: calc(100vh - 48px);
  max-height: calc(100dvh - 48px);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background: #fff;
  color: #1f2937;
  font-size: 14px;
}
.approve-options-dialog *,
.approve-options-dialog *::before,
.approve-options-dialog *::after {
  box-sizing: border-box;
}

/* Header */
.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-shrink: 0;
  gap: 12px;
  padding: 20px 20px 16px 24px;
  border-bottom: 1px solid #e5e7eb;
}
.dialog-header__title {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}
.dialog-header__icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #eef6fc;
  color: #1d67a3;
}
.dialog-header__icon mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.dialog-header__subtitle {
  margin: 2px 0 0;
  font-size: 13px;
  line-height: 1.4;
  color: #6b7280;
}
.dialog-header .close-button {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  padding: 6px;
  color: #6b7280;
}

.dialog-title {
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.3;
  color: #1f2937;
  text-align: left;
}

/* Body */
.dialog-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 24px;
  max-height: 65vh;
  overflow-y: auto;
}

.content-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 10px;
  background: #eef6fc;
  border: 1px solid #cfe3f4;
}
.content-card > mat-icon {
  flex-shrink: 0;
  color: #1d67a3;
}
.content-card__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}
.content-card__type {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #1d67a3;
}
.content-card__title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mode-options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mode-option {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  margin: 0;
  padding: 12px 16px;
  border: 1.5px solid #e5e7eb;
  border-radius: 10px;
  background: #fff;
  color: #1f2937;
  text-align: left;
  font: inherit;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;
}
.mode-option:hover {
  border-color: #cfe3f4;
  background: #fafcfe;
}
.mode-option:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.25);
}
.mode-option__icon {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f3f4f6;
  color: #6b7280;
}
.mode-option__icon mat-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
}
.mode-option__text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.mode-option__text strong {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}
.mode-option__text span {
  font-size: 13px;
  line-height: 1.4;
  color: #6b7280;
}
.mode-option__check {
  flex-shrink: 0;
  color: #c4c9d1;
}
.mode-option--active {
  border-color: var(--fc-brand, #5ea1d8);
  background: #eef6fc;
}
.mode-option--active:hover {
  border-color: var(--fc-brand, #5ea1d8);
  background: #eef6fc;
}
.mode-option--active .mode-option__icon {
  background: #fff;
  color: #1d67a3;
}
.mode-option--active .mode-option__check {
  color: var(--fc-brand, #5ea1d8);
}

.schedule-panel {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 16px 12px;
  border-radius: 10px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
}

.schedule-fields {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 8px;
}
.schedule-fields .date-field {
  flex: 1 1 180px;
}
.schedule-fields .time-field {
  flex: 1 1 130px;
}

.field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
}
.field__label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}
.field__input {
  width: 100%;
  height: 42px;
  padding: 0 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  background: #fff;
  color: #1f2937;
  font: inherit;
  font-size: 14px;
  color-scheme: light;
}
.field__input:focus {
  outline: none;
  border-color: var(--fc-brand, #5ea1d8);
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.2);
}

.schedule-note,
.schedule-error {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 0;
  font-size: 13px;
  line-height: 18px;
}
.schedule-note mat-icon,
.schedule-error mat-icon {
  flex-shrink: 0;
  font-size: 16px;
  width: 16px;
  height: 16px;
  margin-top: 1px;
}

.schedule-note {
  color: #6b7280;
}

.schedule-error {
  color: #c62828;
}

/* Footer */
.dialog-actions {
  flex-shrink: 0;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  padding: 16px 24px;
  border-top: 1px solid #e5e7eb;
  background: #fff;
}

.action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  margin: 0;
  padding: 0 20px;
  border-radius: 8px;
  border: 1px solid transparent;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;
}
.action-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.action-btn--cancel {
  background: #fff;
  border-color: #d1d5db;
  color: #374151;
}
.action-btn--cancel:hover {
  background: #f9fafb;
  border-color: #9ca3af;
}
.action-btn--confirm {
  background: var(--fc-brand, #5ea1d8);
  color: #fff;
}
.action-btn--confirm:hover:not(:disabled) {
  background: #4a8bc4;
  box-shadow: 0 2px 6px rgba(94, 161, 216, 0.3);
}
.action-btn--confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .dialog-header {
    padding: 16px 12px 12px 16px;
  }
  .dialog-body {
    padding: 16px;
  }
  .dialog-actions {
    flex-direction: column-reverse;
    padding: 12px 16px;
  }
  .dialog-actions .action-btn {
    width: 100%;
  }
}
/* Dark theme */
:host-context(body.theme-dark) .approve-options-dialog,
:host-context(body.theme-dark) .dialog-actions {
  background: #1f2937;
  color: #e5e7eb;
}
:host-context(body.theme-dark) .dialog-header,
:host-context(body.theme-dark) .dialog-actions {
  border-color: rgba(148, 163, 184, 0.22);
}
:host-context(body.theme-dark) .dialog-title,
:host-context(body.theme-dark) .content-card__title,
:host-context(body.theme-dark) .mode-option__text strong {
  color: #f1f5f9;
}
:host-context(body.theme-dark) .dialog-header__subtitle,
:host-context(body.theme-dark) .mode-option__text span,
:host-context(body.theme-dark) .schedule-note,
:host-context(body.theme-dark) .close-button {
  color: #94a3b8;
}
:host-context(body.theme-dark) .dialog-header__icon {
  background: #1a2c3d;
  color: #7ec8f0;
}
:host-context(body.theme-dark) .content-card {
  background: #1a2c3d;
  border-color: rgba(94, 161, 216, 0.35);
}
:host-context(body.theme-dark) .content-card > mat-icon,
:host-context(body.theme-dark) .content-card .content-card__type {
  color: #7ec8f0;
}
:host-context(body.theme-dark) .mode-option {
  background: #111827;
  border-color: #374151;
}
:host-context(body.theme-dark) .mode-option:hover {
  background: #162131;
  border-color: rgba(94, 161, 216, 0.45);
}
:host-context(body.theme-dark) .mode-option__icon {
  background: #1f2937;
  color: #94a3b8;
}
:host-context(body.theme-dark) .mode-option__check {
  color: #4b5563;
}
:host-context(body.theme-dark) .mode-option--active {
  border-color: #5ea1d8;
  background: #1a2c3d;
}
:host-context(body.theme-dark) .mode-option--active .mode-option__icon {
  background: #111827;
  color: #7ec8f0;
}
:host-context(body.theme-dark) .mode-option--active .mode-option__check {
  color: #7ec8f0;
}
:host-context(body.theme-dark) .schedule-panel {
  background: #111827;
  border-color: #374151;
}
:host-context(body.theme-dark) .field__label {
  color: #cbd5e1;
}
:host-context(body.theme-dark) .field__input {
  background: #1f2937;
  border-color: #4b5563;
  color: #f1f5f9;
  color-scheme: dark;
}
:host-context(body.theme-dark) .schedule-error {
  color: #fda29b;
}
:host-context(body.theme-dark) .action-btn--cancel {
  background: transparent;
  border-color: #4b5563;
  color: #e2e8f0;
}
:host-context(body.theme-dark) .action-btn--cancel:hover {
  background: #111827;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/user-dashboard/content-approvals/approve-options-dialog/approve-options-dialog.component.scss"],"names":[],"mappings":"AASA;EACE,cAAA;AARF;;AAWA;EACE,WAAA;EACA,8BAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,gBAAA;EACA,cAhBK;EAiBL,eAAA;AARF;AAUE;;;EAGE,sBAAA;AARJ;;AAYA,WAAA;AACA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,cAAA;EACA,SAAA;EACA,4BAAA;EACA,gCAAA;AATF;AAWE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,YAAA;AATJ;AAYE;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBArDS;EAsDT,cAvDQ;AA6CZ;AAYI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAVN;AAcE;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAhEI;AAoDR;AAeE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,cAxEI;AA2DR;;AAiBA;EACE,SAAA;EACA,UAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAnFK;EAoFL,gBAAA;AAdF;;AAiBA,SAAA;AACA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AAdF;;AAiBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAzGW;EA0GX,yBAAA;AAdF;AAgBE;EACE,cAAA;EACA,cA/GQ;AAiGZ;AAiBE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAfJ;AAkBE;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cA9HQ;AA8GZ;AAmBE;EACE,eAAA;EACA,gBAAA;EACA,cAjIG;EAkIH,gBAAA;EACA,uBAAA;EACA,mBAAA;AAjBJ;;AAqBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,SAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAxJK;EAyJL,gBAAA;EACA,aAAA;EACA,eAAA;EACA,uFAAA;AAlBF;AAoBE;EACE,qBAhKgB;EAiKhB,mBAAA;AAlBJ;AAqBE;EACE,aAAA;EACA,8CAAA;AAnBJ;AAsBE;EACE,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAhLI;AA4JR;AAsBI;EACE,eAAA;EACA,WAAA;EACA,YAAA;AApBN;AAwBE;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AAtBJ;AAwBI;EACE,eAAA;EACA,gBAAA;EACA,cApMC;AA8KP;AAyBI;EACE,eAAA;EACA,gBAAA;EACA,cAzME;AAkLR;AA2BE;EACE,cAAA;EACA,cAAA;AAzBJ;AA4BE;EACE,sCAzNI;EA0NJ,mBAvNS;AA6Lb;AA4BI;EACE,sCA7NE;EA8NF,mBA3NO;AAiMb;AA6BI;EACE,gBAAA;EACA,cAjOM;AAsMZ;AA8BI;EACE,+BAvOE;AA2MR;;AAiCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;AA9BF;;AAiCA;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,kBAAA;AA9BF;AAgCE;EACE,eAAA;AA9BJ;AAiCE;EACE,eAAA;AA/BJ;;AAmCA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;AAhCF;AAkCE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAhCJ;AAmCE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAnRG;EAoRH,aAAA;EACA,eAAA;EACA,mBAAA;AAjCJ;AAmCI;EACE,aAAA;EACA,sCA/RE;EAgSF,6CAAA;AAjCN;;AAsCA;;EAEE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;AAnCF;AAqCE;;EACE,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAlCJ;;AAsCA;EACE,cAlTM;AA+QR;;AAsCA;EACE,cAAA;AAnCF;;AAsCA,WAAA;AACA;EACE,cAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,6BAAA;EACA,gBAAA;AAnCF;;AAsCA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,SAAA;EACA,eAAA;EACA,kBAAA;EACA,6BAAA;EACA,aAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,uFAAA;AAnCF;AAqCE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAnCJ;AAsCE;EACE,gBAAA;EACA,qBAAA;EACA,cAAA;AApCJ;AAsCI;EACE,mBAAA;EACA,qBAAA;AApCN;AAwCE;EACE,oCA7WI;EA8WJ,WAAA;AAtCJ;AAwCI;EACE,mBAhXQ;EAiXR,6CAAA;AAtCN;AAyCI;EACE,YAAA;EACA,mBAAA;AAvCN;;AA4CA;EACE;IACE,4BAAA;EAzCF;EA4CA;IACE,aAAA;EA1CF;EA6CA;IACE,8BAAA;IACA,kBAAA;EA3CF;EA6CE;IACE,WAAA;EA3CJ;AACF;AA+CA,eAAA;AAEE;;EAEE,mBAAA;EACA,cAAA;AA9CJ;AAiDE;;EAEE,uCAAA;AA/CJ;AAkDE;;;EAGE,cAAA;AAhDJ;AAmDE;;;;EAIE,cAAA;AAjDJ;AAoDE;EACE,mBAAA;EACA,cAAA;AAlDJ;AAqDE;EACE,mBAAA;EACA,sCAAA;AAnDJ;AAqDI;;EAEE,cAAA;AAnDN;AAuDE;EACE,mBAAA;EACA,qBAAA;AArDJ;AAuDI;EACE,mBAAA;EACA,sCAAA;AArDN;AAwDI;EACE,mBAAA;EACA,cAAA;AAtDN;AAyDI;EACE,cAAA;AAvDN;AA0DI;EACE,qBAAA;EACA,mBAAA;AAxDN;AA0DM;EACE,mBAAA;EACA,cAAA;AAxDR;AA2DM;EACE,cAAA;AAzDR;AA8DE;EACE,mBAAA;EACA,qBAAA;AA5DJ;AA+DE;EACE,cAAA;AA7DJ;AAgEE;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AA9DJ;AAiEE;EACE,cAAA;AA/DJ;AAkEE;EACE,uBAAA;EACA,qBAAA;EACA,cAAA;AAhEJ;AAkEI;EACE,mBAAA;AAhEN","sourcesContent":["$brand: var(--fc-brand, #5ea1d8);\n$brand-hover: #4a8bc4;\n$brand-ink: #1d67a3;\n$brand-tint: #eef6fc;\n$brand-tint-border: #cfe3f4;\n$text: #1f2937;\n$muted: #6b7280;\n$border: #e5e7eb;\n\n:host {\n  display: block;\n}\n\n.approve-options-dialog {\n  width: 100%;\n  max-height: calc(100vh - 48px);\n  max-height: calc(100dvh - 48px);\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n  background: #fff;\n  color: $text;\n  font-size: 14px;\n\n  *,\n  *::before,\n  *::after {\n    box-sizing: border-box;\n  }\n}\n\n/* Header */\n.dialog-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-shrink: 0;\n  gap: 12px;\n  padding: 20px 20px 16px 24px;\n  border-bottom: 1px solid $border;\n\n  &__title {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    min-width: 0;\n  }\n\n  &__icon {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    border-radius: 10px;\n    background: $brand-tint;\n    color: $brand-ink;\n\n    mat-icon {\n      font-size: 22px;\n      width: 22px;\n      height: 22px;\n    }\n  }\n\n  &__subtitle {\n    margin: 2px 0 0;\n    font-size: 13px;\n    line-height: 1.4;\n    color: $muted;\n  }\n\n  .close-button {\n    flex-shrink: 0;\n    width: 36px;\n    height: 36px;\n    padding: 6px;\n    color: $muted;\n  }\n}\n\n.dialog-title {\n  margin: 0;\n  padding: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.3;\n  color: $text;\n  text-align: left;\n}\n\n/* Body */\n.dialog-body {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 20px 24px;\n  max-height: 65vh;\n  overflow-y: auto;\n}\n\n.content-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: 10px;\n  background: $brand-tint;\n  border: 1px solid $brand-tint-border;\n\n  > mat-icon {\n    flex-shrink: 0;\n    color: $brand-ink;\n  }\n\n  &__text {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    min-width: 0;\n  }\n\n  &__type {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    color: $brand-ink;\n  }\n\n  &__title {\n    font-size: 14px;\n    font-weight: 600;\n    color: $text;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n}\n\n.mode-options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.mode-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  margin: 0;\n  padding: 12px 16px;\n  border: 1.5px solid $border;\n  border-radius: 10px;\n  background: #fff;\n  color: $text;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease;\n\n  &:hover {\n    border-color: $brand-tint-border;\n    background: #fafcfe;\n  }\n\n  &:focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.25);\n  }\n\n  &__icon {\n    flex-shrink: 0;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    border-radius: 8px;\n    background: #f3f4f6;\n    color: $muted;\n\n    mat-icon {\n      font-size: 20px;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  &__text {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n\n    strong {\n      font-size: 14px;\n      font-weight: 600;\n      color: $text;\n    }\n\n    span {\n      font-size: 13px;\n      line-height: 1.4;\n      color: $muted;\n    }\n  }\n\n  &__check {\n    flex-shrink: 0;\n    color: #c4c9d1;\n  }\n\n  &--active {\n    border-color: $brand;\n    background: $brand-tint;\n\n    &:hover {\n      border-color: $brand;\n      background: $brand-tint;\n    }\n\n    .mode-option__icon {\n      background: #fff;\n      color: $brand-ink;\n    }\n\n    .mode-option__check {\n      color: $brand;\n    }\n  }\n}\n\n.schedule-panel {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 16px 16px 12px;\n  border-radius: 10px;\n  background: #f9fafb;\n  border: 1px solid $border;\n}\n\n.schedule-fields {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n  margin-bottom: 8px;\n\n  .date-field {\n    flex: 1 1 180px;\n  }\n\n  .time-field {\n    flex: 1 1 130px;\n  }\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0;\n\n  &__label {\n    font-size: 13px;\n    font-weight: 600;\n    color: #374151;\n  }\n\n  &__input {\n    width: 100%;\n    height: 42px;\n    padding: 0 12px;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    background: #fff;\n    color: $text;\n    font: inherit;\n    font-size: 14px;\n    color-scheme: light;\n\n    &:focus {\n      outline: none;\n      border-color: $brand;\n      box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.2);\n    }\n  }\n}\n\n.schedule-note,\n.schedule-error {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin: 0;\n  font-size: 13px;\n  line-height: 18px;\n\n  mat-icon {\n    flex-shrink: 0;\n    font-size: 16px;\n    width: 16px;\n    height: 16px;\n    margin-top: 1px;\n  }\n}\n\n.schedule-note {\n  color: $muted;\n}\n\n.schedule-error {\n  color: #c62828;\n}\n\n/* Footer */\n.dialog-actions {\n  flex-shrink: 0;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 24px;\n  border-top: 1px solid $border;\n  background: #fff;\n}\n\n.action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  margin: 0;\n  padding: 0 20px;\n  border-radius: 8px;\n  border: 1px solid transparent;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background-color 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;\n\n  mat-icon {\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n\n  &--cancel {\n    background: #fff;\n    border-color: #d1d5db;\n    color: #374151;\n\n    &:hover {\n      background: #f9fafb;\n      border-color: #9ca3af;\n    }\n  }\n\n  &--confirm {\n    background: $brand;\n    color: #fff;\n\n    &:hover:not(:disabled) {\n      background: $brand-hover;\n      box-shadow: 0 2px 6px rgba(94, 161, 216, 0.3);\n    }\n\n    &:disabled {\n      opacity: 0.5;\n      cursor: not-allowed;\n    }\n  }\n}\n\n@media (max-width: 480px) {\n  .dialog-header {\n    padding: 16px 12px 12px 16px;\n  }\n\n  .dialog-body {\n    padding: 16px;\n  }\n\n  .dialog-actions {\n    flex-direction: column-reverse;\n    padding: 12px 16px;\n\n    .action-btn {\n      width: 100%;\n    }\n  }\n}\n\n/* Dark theme */\n:host-context(body.theme-dark) {\n  .approve-options-dialog,\n  .dialog-actions {\n    background: #1f2937;\n    color: #e5e7eb;\n  }\n\n  .dialog-header,\n  .dialog-actions {\n    border-color: rgba(148, 163, 184, 0.22);\n  }\n\n  .dialog-title,\n  .content-card__title,\n  .mode-option__text strong {\n    color: #f1f5f9;\n  }\n\n  .dialog-header__subtitle,\n  .mode-option__text span,\n  .schedule-note,\n  .close-button {\n    color: #94a3b8;\n  }\n\n  .dialog-header__icon {\n    background: #1a2c3d;\n    color: #7ec8f0;\n  }\n\n  .content-card {\n    background: #1a2c3d;\n    border-color: rgba(94, 161, 216, 0.35);\n\n    > mat-icon,\n    .content-card__type {\n      color: #7ec8f0;\n    }\n  }\n\n  .mode-option {\n    background: #111827;\n    border-color: #374151;\n\n    &:hover {\n      background: #162131;\n      border-color: rgba(94, 161, 216, 0.45);\n    }\n\n    &__icon {\n      background: #1f2937;\n      color: #94a3b8;\n    }\n\n    &__check {\n      color: #4b5563;\n    }\n\n    &--active {\n      border-color: #5ea1d8;\n      background: #1a2c3d;\n\n      .mode-option__icon {\n        background: #111827;\n        color: #7ec8f0;\n      }\n\n      .mode-option__check {\n        color: #7ec8f0;\n      }\n    }\n  }\n\n  .schedule-panel {\n    background: #111827;\n    border-color: #374151;\n  }\n\n  .field__label {\n    color: #cbd5e1;\n  }\n\n  .field__input {\n    background: #1f2937;\n    border-color: #4b5563;\n    color: #f1f5f9;\n    color-scheme: dark;\n  }\n\n  .schedule-error {\n    color: #fda29b;\n  }\n\n  .action-btn--cancel {\n    background: transparent;\n    border-color: #4b5563;\n    color: #e2e8f0;\n\n    &:hover {\n      background: #111827;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
